export default function constant(a) {
  return _ => a;
}